import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import LogTemplate from '@/views/Log/components/template/template.vue'
import Log from '@/views/Log/models/log'
import CommentComponent from '@/views/Project/Comment/components/comment/comment.vue'
import CommentModel from '@/views/Project/Comment/models/comment'

import { reactionsAll } from '@/views/Project/Comment/models/reaction'
@Component({
    inheritAttrs: false,
    name: 'log-comment',
    components: { LogTemplate, CommentComponent },
})
export default class LogComment extends Mixins<MixinInterface>() {
    @Prop({ required: true }) log!: Log

    reactionsAll = reactionsAll

    get customString() {
        return this.log.logEventName
    }

    newAttachment: any = null
    oldAttachment: any = null
    attachment: any = null
    editorJS: any = null
    comment: CommentModel | null = null

    async mounted() {
        let res = await CommentModel.get(this.log.entityId)
        if (res.parent) {
            this.comment = res.parent
            this.comment.replies = [res]
        } else {
            this.comment = res
        }
    }
}
